import React from 'react'

const UserIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M299.287 255.5h-86.574c-85.147 0-154.418 69.272-154.418 154.418V512h395.41V409.918c0-85.146-69.271-154.418-154.418-154.418zM256 0c-65.843 0-119.409 53.567-119.409 119.41 0 65.842 53.566 119.409 119.409 119.409s119.409-53.567 119.409-119.41C375.409 53.567 321.843 0 256 0z"
      />
    </svg>
  )
}

UserIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default UserIcon
